import * as React from 'react';
import { UNSAFE_getMoment } from '../../../helpers/datetime';
import {
  fullMonths,
  getWeekDaysName,
  shortMonths
} from '../../../helpers/localization/localizationUtils';
import { DatePickerI18n, DatePickerI18nContext } from '../../lab/DateRangePicker';

const moment = UNSAFE_getMoment();

export function DatePickerLabelsProvider(
  props: React.PropsWithChildren<{
    localizationData: Record<string, $TSFixMe>;
    translate: TranslateFn;
    weekdayFormat: string;
    monthFormatForElements: Array<string>;
  }>
) {
  const isZH = React.useMemo(
    () => props.monthFormatForElements.includes(props.localizationData._config.abbr.toLowerCase()),
    [props.localizationData._config.abbr, props.monthFormatForElements]
  );

  const datePickerI18nData: DatePickerI18n = React.useMemo(() => {
    return {
      months: isZH
        ? shortMonths(props.translate, props.localizationData)
        : fullMonths(props.translate, props.localizationData),
      isZh: isZH,
      weekDays:
        getWeekDaysName(props.weekdayFormat, props.translate, props.localizationData) ?? undefined,
      format: moment ? (date, format) => moment(date).format(format) : undefined,
      parse: moment ? (date, format) => moment(date, format).toDate() : undefined
    };
  }, [isZH, props.localizationData, props.translate, props.weekdayFormat]);

  return (
    <DatePickerI18nContext.Provider value={datePickerI18nData}>
      {props.children}
    </DatePickerI18nContext.Provider>
  );
}
